// Contentful で特定のフィールドに en がなければ 404 的な表示する
// locale en でしか表示されない
export const NoTranslationFound = () => (
  <div style={{ width: "auto", height: "100%" }}>No Translation Found</div>
)
